<template>
    <div>
        <el-button plain @click="showCreateDialoe">创建微调</el-button>
        <el-button type="primary" icon="el-icon-search" @click="tuneList">加载</el-button>
        <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        :row-class-name="tableRowClassName">
        <el-table-column
            prop="id"
            label="ID"
            width="260">
        </el-table-column>organizationId
        <el-table-column
            prop="organizationId"
            label="organizationId"
            width="300">
        </el-table-column>
        <el-table-column
            prop="trainingFiles"
            label="file_id"
            width="280">
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.trainingFiles" :key="index">{{ item.id }}</span>
            </template>
        </el-table-column>
        <el-table-column
            prop="object"
            label="object"
            width="180">
        </el-table-column>
        <el-table-column
            prop="model"
            label="基础模型">
        </el-table-column>
        
        <el-table-column
            prop="status"
            label="状态">
        </el-table-column>
        <el-table-column
            prop="createdAt"
            label="创建时间">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.createdAt) }}</span>

            </template>
        </el-table-column>
      
        <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button @click="deleteBtn(scope.row.id)" circle type="danger">删除</el-button>
              <!--<el-button @click="cancel(scope.row.id)" circle type="danger">取消</el-button>-->
              <!--<el-button @click="detail(scope.row.id)" circle type="success">详情</el-button>-->
           <!--   <el-button @click="analyses(scope.row)" circle type="success">分析</el-button>-->
            </template>
        </el-table-column>
        </el-table>

        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span>
                
                <el-form :model="from" ref="from" label-width="100px" class="demo-dynamic">
                    
                 
                  <el-form-item label="选择文件" prop="file_id">
                    <el-select v-model="from.file_id" placeholder="请选择文件">
                      <el-option
                        v-for="item in file_options"
                        :key="item.file_id"
                        :label="item.file_id"
                        :value="item.file_id">
                      </el-option>
                    </el-select>

                  </el-form-item>
                  <el-form-item label="选择模型" prop="model">
                    <el-select v-model="from.model" placeholder="请选择模型">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>

                  </el-form-item>
                </el-form>

            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('from')">确 定</el-button>
            </span>
          </el-dialog>
          
          <el-dialog
            title="提示"
            :visible.sync="centerAnalyseDialogVisible"
            width="30%"
            center>
            <el-descriptions title="自定义样式列表" :column="3" border>
  <el-descriptions-item label="用户名" label-class-name="my-label" content-class-name="my-content">kooriookami</el-descriptions-item>
  <el-descriptions-item label="手机号">18100000000</el-descriptions-item>
  <el-descriptions-item label="居住地">苏州市</el-descriptions-item>
  <el-descriptions-item label="备注">
    <el-tag size="small">学校</el-tag>
  </el-descriptions-item>
  <el-descriptions-item label="联系地址" :contentStyle="{'text-align': 'right'}">江苏省苏州市吴中区吴中大道 1188 号</el-descriptions-item>
</el-descriptions>
            <span>id:{{ detailObj.id }}</span>
            <span>model:{{ detailObj.model }}</span>
            <span>object:{{ detailObj.object }}</span>
            <span>organizationId:{{ detailObj.organizationId }}</span>

            <span>status:{{ detailObj.status }}</span>

            <span slot="footer" class="dialog-footer">
              <el-button @click="centerDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>


    </div>
  </template>
  
  <style>
    .el-table .warning-row {
      background: oldlace;
    }
  
    .el-table .success-row {
      background: #f0f9eb;
    }
    .my-label {
    background: #E1F3D8;
  }

  .my-content {
    background: #FDE2E2;
  }
  </style>
  
  <script>

  import {Message} from 'element-ui';
    export default {
     
      data() {
        return {
          detailObj:{},
          centerAnalyseDialogVisible:false,
          params:{},
          centerDialogVisible: false,
          tableData: [],
          from: {
            file_id: '',
            model:'Ada',
         },
         options: [{
          value: 'Davinci',
          label: 'Davinci'
        }, {
          value: 'Curie',
          label: 'Curie'
        }, {
          value: 'Babbage',
          label: 'Babbage'
        }, {
          value: 'Ada',
          label: 'Ada'
        }],
        file_options: [],
        value: 'Ada',
        file_id_value:''
        }
      },
      methods: {
        analyses(obj){
          let self = this;
          self.centerAnalyseDialogVisible = true;
          var params = {fileId:obj.trainingFiles[0].id};
          self.postRequest('/fineTune/analyses',params).then(resp =>{
              console.log(resp.data);
              self.detailObj = resp.data;
            })
        },
        detail(id){
          let self = this;
          self.centerAnalyseDialogVisible = true;
          var params = {fineTuneId:id};
          self.postRequest('/fineTune/get',params).then(resp =>{
              console.log(resp.data);
              self.detailObj = resp.data;
            })
        },
        tableRowClassName({row, rowIndex}) {
          if (rowIndex === 1) {
            return 'warning-row';
          } else if (rowIndex === 3) {
            return 'success-row';
          }
          return '';
        },
        deleteBtn(id){

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
              let self = this;
              let params = {
                fileId : id
              }
              self.postRequest('/fineTune/delete',params).then(resp =>{
                Message.success({message: resp.msg})
                self.tuneList();
              })
            }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消删除'
              });          
            });

             
        },
        cancel(id){
             let self = this;
             let params = {
              fileId : id
             }
            self.postRequest('/fineTune/cancel',params).then(resp =>{
              Message.success({message: resp.msg})
              self.tuneList();
            })
        },
        tuneList(){
            let self = this;
            self.postRequest('/fineTune/list',self.params).then(resp =>{
             self.tableData = resp.data;
            })
        },
        fileList(){
            let self = this;
            self.postRequest('/fineTuneFile/fileList',{}).then(resp =>{
             self.file_options = resp.data;
            })
        },
        showCreateDialoe(){
            this.centerDialogVisible = true;
        },
        submitForm(formName) {
            console.log("formName:"+JSON.stringify(this.from));
            this.centerDialogVisible=false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let self = this;
                self.postRequest('/fineTune/add',self.from).then(resp =>{
                    Message.success({message: resp.msg})
                    self.tuneList();
                    self.resetForm(formName);
                })  

            } else {
                Message.error({message: "表单验证失败"})
                return false;
            }
            });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      },
      created(){
        this.fileList();
        this.tuneList();
     }
    }
  </script>